/**
 * The page's activities/{id} request returns the nested content the video, slide deck, LTI
 * tool, LTI resource link and flashcard renderers show (Phase 7). Use it when it is there instead of asking for
 * the activity again. Activity templates in the editor, an activity loaded without that
 * content, and a status poll still fetch.
 *
 * @param {object} options
 * @param {string|null} options.namespace The renderer's store namespace.
 * @param {object|null|undefined} options.activityContent The loaded activity's activity_content.
 * @param {string} options.key The nested content the renderer reads, such as `video`.
 * @param {() => Promise<object|null|undefined>} options.fetch Requests activity_content.
 * @param {boolean} [options.refresh] Skip the loaded content, as a status poll must.
 * @returns {Promise<object|null|undefined>}
 */
export async function loadRendererActivityContent({ namespace, activityContent, key, fetch, refresh = false }) {
    if (!refresh && namespace === 'Activities' && activityContent && Object.hasOwn(activityContent, key)) {
        return activityContent;
    }

    return fetch();
}
